<template>
  <!-- 购买IG物品弹窗 -->
  <div>
    <!-- IG饰品列表 -->
    <el-dialog
      :visible.sync="igVisible"
      title="IG饰品列表"
      :close-on-click-modal="false"
      width="930px"
      @close="closeDialog"
    >
      <el-row style="margin-bottom: 20px">
        <el-select
          style="width: 150px; margin-right: 20px"
          v-model="prizeType"
          placeholder="请选择奖品分类"
        >
          <el-option :value="1" label="csgo"></el-option>
          <el-option :value="5" label="dota"></el-option>
        </el-select>
        <el-input
          style="width: 200px; margin-right: 20px"
          placeholder="商品名称搜索"
          v-model="prizeInfo.prizeName"
        >
        </el-input>
        <el-button type="primary" @click="getSearch(1)">搜索</el-button>
      </el-row>
      <div class="prize-list-wrap" v-loading="loadingProduct">
        <ul class="prize-list">
          <li
            class="prize-item"
            v-for="item in prizeList"
            :key="item.product_id"
          >
            <i
              class="el-icon-view"
              title="查看在售列表"
              @click="showigSell(item)"
            ></i>
            <img :src="item.icon_url" alt />
            <p>
              <span>{{ item.name }}</span>
            </p>
            <p>
              <span>{{ item.exterior_name }}</span>
            </p>
            <p>
              <span>{{ item.quality_name }}</span>

              <span class="price">{{ item.buy_min_price }} 元</span>
            </p>
            <p style="text-align: center">数量：{{ item.buy_sale_count }}</p>
          </li>
        </ul>

        <!-- IG饰品列表底部分页 -->
        <ul class="pagination" v-if="productMeta" title="首页">
          <li
            :class="`home-page ${
              productMeta.current_page === 1 ? 'active' : ''
            }`"
            @click="handleIGPageChange(1)"
          >
            首页
          </li>
          <li
            v-if="productMeta.current_page != 1"
            class="item-page previous-page"
            @click="handleIGPageChange(2)"
            title="上一页"
          >
            <i class="el-icon-arrow-left"></i>
          </li>
          <li
            v-if="productMeta.total_pages === 1"
            class="item-page next-page"
            @click="handleIGPageChange(3)"
            title="下一页"
          >
            <i class="el-icon-arrow-right"></i>
          </li>
          <span> 第{{ productMeta.current_page }}页 </span>
        </ul>
      </div>
    </el-dialog>

    <!--IG商品在售列表-->
    <el-dialog
      :visible.sync="sellProductVisible"
      title="IG商品在售列表"
      :close-on-click-modal="false"
      width="1000px"
      @close="closeSellDialog"
    >
      <div class="prize-list-wrap" v-loading="loadingSellProduct">
        <ul class="prize-list">
          <li
            class="prize-item"
            v-for="sellerInfo in prizeSellList"
            :key="sellerInfo.id"
            :style="`${sellerInfo.is_red ? 'background-color:#ff00004a;' : ''}`"
          >
            <i
              v-if="typeNum === 1"
              class="el-icon-wallet"
              title="购买物品"
              @click="igDeliver(sellerInfo)"
            ></i>
            <img :src="sellerInfo.icon_url" alt />
            <p>
              <span>{{ sellerInfo.name }}</span>
            </p>
            <p>
              <span
                >发货类型:{{
                  sellerInfo.delivery_type === 2 ? "手动发货" : "极速发货"
                }}</span
              >
            </p>
            <p>
              <span>{{ sellerInfo.unit_price }}元</span>
            </p>
          </li>
        </ul>

        <!-- IG在售物品底部分页 -->
        <ul class="pagination" v-if="sellProductMeta" title="首页">
          <li
            :class="`home-page ${
              sellProductMeta.current_page === 1 ? 'active' : ''
            }`"
            @click="handleIGSellPageChange(1)"
          >
            首页
          </li>
          <li
            v-if="sellProductMeta.current_page != 1"
            class="item-page previous-page"
            @click="handleIGSellPageChange(2)"
            title="上一页"
          >
            <i class="el-icon-arrow-left"></i>
          </li>
          <li
            v-if="sellProductMeta.total_pages === 1"
            class="item-page next-page"
            @click="handleIGSellPageChange(3)"
            title="下一页"
          >
            <i class="el-icon-arrow-right"></i>
          </li>
          <span> 第{{ sellProductMeta.current_page }}页 </span>
        </ul>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import { mapState, mapActions } from 'vuex'
import http, { patchData, server, postApiData, getApiData } from '../../http'
export default {
  props: {
    value: {
      type: Object,
      default: undefined
    },
    visible: {
      type: Boolean,
      default: false
    },
    typeNum: {//1显示购买按钮 2不显示购买按钮
      type: Number,
      default: 1
    }
  },
  data() {
    return {
      buyLock: false,//购买锁
      sellProductVisible: false,//在售列表弹窗显示标志
      loadingProduct: false,//饰品列表加载动画
      loadingSellProduct: false,//饰品在售列表加载动画
      prizeType: 1,//第三方奖品类别 1是csgo 5是dota
      prizeList: undefined,//饰品列表数据
      prizeSellList: undefined,//饰品售卖列表数据
      productId: undefined,//要查看售卖列表的饰品ID
      productMeta: undefined,//饰品列表底部分页
      sellProductMeta: undefined,//在售列表底部分页
      queryProduct: {
        page: 1
      },
      querySellProduct: {
        page: 1
      }
    }
  },
  computed: {
    //商品信息
    prizeInfo: {
      get() {
        return this.value
      },
      set() { }
    },
    igVisible: {
      get() {
        // return this.visible
        //跳过模糊查询列表，直接打开在售列表弹窗
        return false
      },
      set() { }
    }
  },
  watch: {
    prizeInfo(val) {
      if (val) {
        // this.getSearch(1)
        //跳过模糊查询列表，直接打开在售列表弹窗
        this.showigSell()
      }
    },
  },
  created() { },
  mounted() { },
  methods: {
    //根据品质查询的物品列表
    getSearch(num) {
      if (num == 1) {
        this.queryProduct.page = 1
      }
      //搜索物品
      this.loadingProduct = true

      let appId = undefined
      if (this.prizeType === 1) {
        appId = 730
      } else if (this.prizeType === 5) {
        appId = 570
      }
      let params = {
        app_id: appId,
        page: this.queryProduct.page,
        name: this.prizeInfo.prizeName
      }
      getApiData(`ig/list`, params)
        .then(res => {
          this.prizeList = res.products
          if (res.page) {
            //设置底部导航条数据
            this.productMeta = {
              current_page: res.page.page_no, //当前页标
              total_pages: res.page.is_more, //是否有下一页 1代表有 0代表无
            }
          }
        })
        .finally(() => {
          this.loadingProduct = false
        })
    },
    //查看在售列表
    showigSell(rowInfo) {
      this.sellProductVisible = true
      // this.productId = rowInfo.product_id
      //查询在售列表
      this.getIgSellProduct(1)
    },
    //获取在售列表数据
    getIgSellProduct(num) {
      if (num == 1) {
        this.querySellProduct.page = 1
      }
      let appId = undefined
      if (this.prizeType === 1) {
        appId = 730
      } else if (this.prizeType === 5) {
        appId = 570
      }
      this.loadingSellProduct = true
      let params = {
        app_id: appId,
        page: this.querySellProduct.page,
        market_hash_name: this.prizeInfo.market_hash_name,
        // product_id: this.productId
      }
      getApiData(`ig/trade_list`, params)
        .then(res => {
          this.prizeSellList = res.data.products
          if (res.data && res.data.page) {
            //设置底部导航条数据
            this.sellProductMeta = {
              current_page: res.data.page.page_no, //当前页标
              total_pages: res.data.page.is_more, //是否有下一页 1代表有 0代表无
            }
          }
        })
        .finally(() => {
          this.loadingSellProduct = false
        })
    },
    igDeliver(rowInfo) {
      //购买饰品
      if (this.buyLock) {
        //防止重复点击
        this.$message.error("请勿重复点击！")
        return
      }

      let appId = undefined
      if (this.prizeType === 1) {
        appId = 730
      } else if (this.prizeType === 5) {
        appId = 570
      }

      let params = {
        app_id: appId,
        product_id: this.productId,
        trade_id: rowInfo.trade_id,
        unit_price: rowInfo.unit_price
      }
      this.buyLock = true
      postApiData(`ig/buy/` + this.prizeInfo.orderId, params)
        .then(res => {
          this.$message.success('购买成功')
          this.closeSellDialog()//关闭饰品在售列表弹窗
          this.closeDialog()//关闭饰品列表弹窗
          this.$emit("refresh")//刷新列表
          //解锁
          this.buyLock = false
        }).catch(error => {
          //解锁
          this.buyLock = false
        })
    },
    handleIGPageChange(num) {
      //切换饰品列表的分页
      switch (num) {
        case 1:
          this.queryProduct.page = 1;//首页
          break;
        case 2:
          this.queryProduct.page = this.queryProduct.page - 1;//上一页
          break;
        case 3:
          this.queryProduct.page = this.queryProduct.page + 1;//下一页
          break;
      }
      this.getSearch()//搜索数据
    },
    handleIGSellPageChange(num) {
      //切换在售列表的分页
      switch (num) {
        case 1:
          this.querySellProduct.page = 1;//首页
          break;
        case 2:
          this.querySellProduct.page = this.querySellProduct.page - 1;//上一页
          break;
        case 3:
          this.querySellProduct.page = this.querySellProduct.page + 1;//下一页
          break;
      }
      this.getIgSellProduct()//搜索数据
    },
    closeDialog() {
      //关闭饰品列表弹窗
      this.$emit("close")
      this.queryProduct.page = 1
      this.querySellProduct.page = 1
      this.prizeList = []
      this.prizeSellList = []
    },
    closeSellDialog() {
      // 关闭饰品在售列表弹窗
      this.sellProductVisible = false
    }
  }
}
</script>
<style lang="less" scoped>
//IG底部分夜样式
.pagination {
  display: flex;
  align-items: center;

  li {
    display: flex;
    justify-content: center;
    align-items: center;
    margin-right: 20px;
    cursor: pointer;
    background-color: #f4f4f5;
    color: #606266;
    border-radius: 2px;

    &:hover {
      background-color: #409eff;
      color: #fff;
    }
  }

  .home-page {
    min-width: 40px;
    height: 30px;
    background-color: #f4f4f5;
    color: #606266;
    border-radius: 2px;
    height: 30px;
  }

  .item-page {
    min-width: 30px;
    height: 30px;
  }

  .active {
    background-color: #409eff;
    color: #fff;
  }
}
</style>
